import { AuthContextProps } from "../components/auth-context";
import { getData } from "./core";

export default class UserInfoApi {
  static unauthorizedUri = "n/accounts/agent";
  static authorizedUri = "a/accounts/agent";
  context?: AuthContextProps;
  constructor(context?: AuthContextProps) {
    this.context = context;
  }
  get() {
    return getData({
      id: "_",
      uri: UserInfoApi.unauthorizedUri,
      context: this.context,
    });
  }
}
